!function(){let e,t=!1;document.body.addEventListener("touchstart",(function(c){c.target.closest(".flickity-slider")?(t=!0,e={x:c.touches[0].pageX,y:c.touches[0].pageY}):t=!1})),document.body.addEventListener("touchmove",(function(c){if(!t||!c.cancelable)return;let n={x:c.touches[0].pageX-e.x,y:c.touches[0].pageY-e.y};Math.abs(n.x)>7&&c.preventDefault()}),{passive:!1})}();

/* Cart Upsell Modal – uses event delegation so it works after AJAX re-renders */
(function() {
  /* Always find the modal nearest to the clicked element, or the open one */
  function findModal(fromEl) {
    if (fromEl) {
      var closest = fromEl.closest('[data-upsell-modal]');
      if (closest) return closest;
    }
    return document.querySelector('[data-upsell-modal][aria-hidden="false"]')
        || document.querySelector('[data-upsell-modal]');
  }

  function openModal(triggerEl) {
    /* Find the modal that is a sibling of the trigger's upsell block */
    var upsellBlock = triggerEl ? triggerEl.closest('[data-cart-upsell]') : null;
    var modal = upsellBlock ? upsellBlock.parentElement.querySelector('[data-upsell-modal]') : findModal(null);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(fromEl) {
    var modal = findModal(fromEl);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openPopover(fromEl) {
    var modal = findModal(fromEl);
    if (!modal) return;
    var popover = modal.querySelector('[data-upsell-popover]');
    var trigger = modal.querySelector('[data-action="toggle-upsell-popover"]');
    if (popover) popover.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closePopover(fromEl) {
    var modal = findModal(fromEl);
    if (!modal) return;
    var popover = modal.querySelector('[data-upsell-popover]');
    var trigger = modal.querySelector('[data-action="toggle-upsell-popover"]');
    if (popover) popover.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  /* Delegated click handler on body */
  document.body.addEventListener('click', function(e) {
    /* Open modal */
    var openBtn = e.target.closest('[data-action="open-upsell-modal"]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn);
      return;
    }

    /* Close modal */
    if (e.target.closest('[data-action="close-upsell-modal"]')) {
      e.preventDefault();
      closeModal(e.target);
      return;
    }

    /* Toggle variant popover */
    if (e.target.closest('[data-action="toggle-upsell-popover"]')) {
      e.preventDefault();
      var modal = findModal(e.target);
      if (!modal) return;
      var popover = modal.querySelector('[data-upsell-popover]');
      if (popover && popover.getAttribute('aria-hidden') === 'true') {
        openPopover(e.target);
      } else {
        closePopover(e.target);
      }
      return;
    }

    /* Close variant popover */
    if (e.target.closest('[data-action="close-upsell-popover"]')) {
      e.preventDefault();
      closePopover(e.target);
      return;
    }

    /* Select variant from popover */
    var variantBtn = e.target.closest('[data-action="select-upsell-variant"]');
    if (variantBtn) {
      e.preventDefault();
      var modal = findModal(variantBtn);
      if (!modal) return;

      var variantId = variantBtn.getAttribute('data-variant-id');
      var label = variantBtn.getAttribute('data-variant-label');
      var price = variantBtn.getAttribute('data-variant-price');

      /* Update hidden input */
      var hiddenInput = modal.querySelector('[data-upsell-variant-select]');
      if (hiddenInput) hiddenInput.value = variantId;

      /* Update button label */
      var selectedLabel = modal.querySelector('[data-upsell-selected-label]');
      if (selectedLabel) selectedLabel.textContent = label;

      /* Update prices */
      var priceDisplay = modal.querySelector('[data-upsell-price]');
      var buttonPrice = modal.querySelector('[data-upsell-button-price]');
      if (priceDisplay) priceDisplay.textContent = price;
      if (buttonPrice) buttonPrice.textContent = price;

      /* Update selected state */
      modal.querySelectorAll('[data-action="select-upsell-variant"]').forEach(function(btn) {
        btn.classList.remove('is-selected');
      });
      variantBtn.classList.add('is-selected');

      closePopover(variantBtn);
      return;
    }

    /* Add to cart */
    var addBtn = e.target.closest('[data-upsell-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var modal = findModal(addBtn);
      if (!modal) return;

      var monthSelect = modal.querySelector('[data-upsell-birthday-month]');
      var daySelect = modal.querySelector('[data-upsell-birthday-day]');
      var birthdayInput = modal.querySelector('[data-upsell-birthday]');
      if (monthSelect && daySelect) {
        if (!monthSelect.value) { monthSelect.focus(); return; }
        if (!daySelect.value) { daySelect.focus(); return; }
        var dd = daySelect.value.length === 1 ? '0' + daySelect.value : daySelect.value;
        birthdayInput.value = '2000-' + monthSelect.value + '-' + dd;
      }

      addBtn.disabled = true;
      addBtn.querySelector('span').textContent = 'Adding...';

      var variantInput = modal.querySelector('[data-upsell-variant-select]');
      var sellingPlanInput = modal.querySelector('[data-upsell-selling-plan]');
      var variantId = variantInput ? variantInput.value : null;

      var body = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {}
        }]
      };

      if (birthdayInput && birthdayInput.value) {
        body.items[0].properties['Birthday'] = birthdayInput.value;
      }

      if (sellingPlanInput) {
        body.items[0].selling_plan = parseInt(sellingPlanInput.value, 10);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return res.json();
      })
      .then(function() {
        closeModal(addBtn);
        window.location.reload();
      })
      .catch(function() {
        addBtn.disabled = false;
        addBtn.querySelector('span').textContent = 'Add to Cart';
        alert('Something went wrong. Please try again.');
      });
      return;
    }
  });

  /* Desktop select syncs hidden input + prices */
  document.body.addEventListener('change', function(e) {
    var select = e.target.closest('[data-upsell-variant-desktop]');
    if (!select) return;
    var modal = findModal(select);
    if (!modal) return;
    var selected = select.options[select.selectedIndex];
    var price = selected.getAttribute('data-price');
    var hiddenInput = modal.querySelector('[data-upsell-variant-select]');
    if (hiddenInput) hiddenInput.value = select.value;
    var priceDisplay = modal.querySelector('[data-upsell-price]');
    var buttonPrice = modal.querySelector('[data-upsell-button-price]');
    if (priceDisplay) priceDisplay.textContent = price;
    if (buttonPrice) buttonPrice.textContent = price;
  });

  /* Escape key closes modal */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var modal = document.querySelector('[data-upsell-modal][aria-hidden="false"]');
      if (modal) closeModal(modal);
    }
  });
})();

/* Product page birthday month/day → hidden combined field */
(function() {
  document.body.addEventListener('change', function(e) {
    var monthEl = e.target.closest('[data-birthday-month]');
    var dayEl = e.target.closest('[data-birthday-day]');
    var productId = monthEl ? monthEl.getAttribute('data-birthday-month') : (dayEl ? dayEl.getAttribute('data-birthday-day') : null);
    if (!productId) return;
    var month = document.querySelector('[data-birthday-month="' + productId + '"]');
    var day = document.querySelector('[data-birthday-day="' + productId + '"]');
    var hidden = document.querySelector('[data-birthday-combined="' + productId + '"]');
    if (month && day && hidden) {
      if (month.value && day.value) { var dd = day.value.length === 1 ? '0' + day.value : day.value; hidden.value = '2000-' + month.value + '-' + dd; } else { hidden.value = ''; }
    }
  });
})();
